import { formatRelativeTime } from '@buyerflo/ui/utils/time'
import { useEffect, useState } from 'react'

function useNow(refreshFrequencyMs: number): Date {
    const [now, setNow] = useState(new Date())
    useEffect(() => {
        const interval = setInterval(() => setNow(new Date()), refreshFrequencyMs)
        return () => clearInterval(interval)
    })
    return now
}

export const useFormatNotificationTime = () => {
    const now = useNow(1000 * 60)
    return (notificationTime: number) => formatRelativeTime(notificationTime, now)
}

export const NOTIFICATION_BUCKETS = ['Today', 'Yesterday', 'This week', 'Earlier'] as const
export type NotificationBucket = (typeof NOTIFICATION_BUCKETS)[number]

const DAY_MS = 1000 * 60 * 60 * 24
const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime()

/**
 * Returns a classifier that groups a notification's timestamp into a recency
 * bucket (Today / Yesterday / This week / Earlier), re-evaluated each minute so
 * buckets roll over as time passes. "This week" covers the last 7 calendar days.
 */
export const useNotificationBucket = () => {
    const now = useNow(1000 * 60)
    return (notificationTime: number): NotificationBucket => {
        const todayStart = startOfDay(now)
        if (notificationTime >= todayStart) return 'Today'
        if (notificationTime >= todayStart - DAY_MS) return 'Yesterday'
        if (notificationTime >= todayStart - 6 * DAY_MS) return 'This week'
        return 'Earlier'
    }
}
